import { styled } from '@mui/material/styles';

export const GalleryImageWrapper = styled('div')(({ theme }) => ({
  position: 'relative',
  width: '100%',
  aspectRatio: '16/10',
  [theme.breakpoints.down('md')]: {
    height: 220,
  },
  [theme.breakpoints.down('sm')]: {
    height: 192,
  },
}));

export const GalleryImage = styled('img')(({ theme }) => ({
  display: 'block',
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  borderRadius: 16,
  maxWidth: '100%',
  position: 'absolute',
  top: 0,
  left: 0,
  opacity: 1,
  transition: 'opacity 0.4s',
  '&.gallery-fade-out': {
    opacity: 0,
    zIndex: 1,
  },
  '&.gallery-fade-in': {
    opacity: 1,
    zIndex: 2,
  },
}));

export const GalleryThumb = styled('img')(({ theme }) => ({
  width: 56,
  height: 56,
  objectFit: 'cover',
  borderRadius: 16,
  border: `2px solid transparent`,
  cursor: 'pointer',
  marginRight: 8,
  transition: 'border 0.2s',
  boxShadow: 'none',
  '&.active': {
    border: `2px solid ${theme.palette.primary.main}`,
    boxShadow: theme.shadows[2],
  },
}));
